import {StringHelper} from "./stringHelper";
import {InstanceHelper} from "./instanceHelper";
import IModel from "../interfaces/modelInterfaces";
import {Route, RouteUrlTemplate} from "../enums/route";

interface INamedWildcardOption {
  wildcard: string;
  modelOrId: string;
}

function getId(modelOrId: string | IModel): string {
  if (InstanceHelper.isString(modelOrId)) {
    return modelOrId;
  } else {
    return modelOrId.id;
  }
}

function replaceId(template: string, id: string): string {
  return template.replace(':id', id);
}

function replaceNamedWildcards(template: string, namedWildcards: Array<INamedWildcardOption>): string {
  namedWildcards.forEach(r => template = template.replace(r.wildcard, getId(r.modelOrId)));
  return template;
}

export interface IBasePathArgs {
  modelOrId?: IModel | string
  query?: object
  hash?: string
  namedWildcardOptions?: Array<INamedWildcardOption>
}

export let RouteHelper = {
  rootUrl: function(opts: {subdomain?} = {}): string {
    if (opts.subdomain) {
      const delimiter = '//';
      return StringHelper.splice(window.AppConfig.rootUrl, window.AppConfig.rootUrl.indexOf(delimiter) + delimiter.length, 0, `${opts.subdomain}.`);
    } else {
      return window.AppConfig.rootUrl;
    }
  },
  path(opts: IBasePathArgs & ({ route: Route } | { path: string })): string {
    let path: string = ('route' in opts) ? RouteUrlTemplate[opts.route] : opts.path;
    if (opts.modelOrId) {
      path = replaceId(path, getId(opts.modelOrId))
    }
    if (opts.namedWildcardOptions) {
      path = replaceNamedWildcards(path, opts.namedWildcardOptions)
    }
    if (opts.query && Object.keys(opts.query).length > 0) {
      path += '?' + $.param(opts.query);
    }
    if (opts.hash) {
      path += '#' + opts.hash
    }
    return path;
  },
  namedWildcardOptionsFactory(resources: object) {
    return Object.keys(resources).map(resourceName => ({wildcard: `:${resourceName}_id`, modelOrId: resources[resourceName]}));
  }
};
